import React from "react";
import { Box, Typography } from "@curves/ui-base";
import { formatCurrencyFn, isEmpty } from "@util/utils";
import { MemberInfoCard, MemoControllerBox, OverflowMenu } from "@icoach/components";
import { StatusChipTooltip } from "@icoach/rentCabinet/CabinetOverviewTable";
import { COLOR_MATCH } from "@icoach/accountBook/staticData";
import { buildOrderMenuData } from "@icoach/accountBook/utils/buildOrderMenuData";

export const getDebitCreditCardRowsLabel = () => [
	{
		cellKey: "displayName",
		headerLabel: "會員",
		align: "left",
		maxWidth: 20.4,
		formatCell: (displayName, { maskDisplayName, memberNo, memberPicturePath }, { isRevealed }) => {
			return <MemberInfoCard name={isRevealed ? displayName : maskDisplayName} memberNo={memberNo}
								   avatar={memberPicturePath} />;
		}
	},
	{
		cellKey: "statusText",
		headerLabel: "狀態",
		align: "center",
		formatCell: (cellValue, { status, statusColor = 0, processResult }) => {
			return <StatusChipTooltip statusText={cellValue} statusMemo={processResult} color={COLOR_MATCH[statusColor]}
									  isShowTip={String(status) === "9"} />;
		}
	},
	{
		cellKey: "itemName",
		headerLabel: "品項",
		formatCell: (cellValue, { itemQtySet }) => {
			if (!isEmpty(itemQtySet)) {
				return (
					<Box component={"ul"} className={"item-list"}>
						{itemQtySet.map((text, i) => {
							return (
								<Box component={"li"} key={i}>
									{text}
								</Box>
							);
						})}
					</Box>
				);
			}
			return cellValue;
		}
	},
	{
		cellKey: "totalPrice",
		headerLabel: "扣款金額",
		align: "center",
		formatCell: (cellValue) => {
			return formatCurrencyFn(cellValue);
		}
	},
	{
		cellKey: "returnPrice",
		headerLabel: "退款金額",
		align: "center",
		formatCell: (cellValue) => {
			return formatCurrencyFn(cellValue);
		}
	},
	{
		cellKey: "invoiceNo",
		headerLabel: "發票號碼",
		align: "center"
	},
	{
		cellKey: "creditCardNo",
		headerLabel: "信用卡",
		maxWidth: 21,
		formatCell: (cellValue, { cardExpiryDate }) => {
			return (
				<Box className="payment-card-content">
					<Typography className={"title"} variant="body1" component={"h6"}>
						{cellValue}
					</Typography>
					{cardExpiryDate ? (
						<Typography className={"sub-title font-color-3"} variant="body2">
							{`有效期限：${cardExpiryDate}`}
						</Typography>
					) : (
						""
					)}
				</Box>
			);
		}
	},
	{
		cellKey: "notes",
		headerLabel: "備註",
		formatCell: (cellValue) => {
			return <MemoControllerBox data={cellValue} dialogTitle={"備註"} />;
		}
	},
	{
		cellKey: "more",
		headerLabel: "",
		width: 6.8,
		formatCell: (_, rowData, { refresh, dialogRef }) => {
			const menuData = buildOrderMenuData(rowData, { refresh, dialogRef });
			return <OverflowMenu menuData={menuData} />;
		},
	}
];
